"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminRegistrationReminderRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class AdminRegistrationReminderRequestDto {}
exports.AdminRegistrationReminderRequestDto = AdminRegistrationReminderRequestDto;
__decorate([(0, swagger_1.ApiPropertyOptional)({
  description: 'Push notification message. Falls back to the default registration reminder copy when omitted.'
}), __metadata("design:type", String)], AdminRegistrationReminderRequestDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)({
  description: 'Optional cap on how many real (non-internal) Pending users to notify. Never-reminded users are sent first. Omit to send to the full eligible audience.',
  minimum: 1
}), __metadata("design:type", Number)], AdminRegistrationReminderRequestDto.prototype, "limit", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)({
  description: 'Optional pause in milliseconds between OneSignal batches. Defaults to the re-engage batch interval. Must be between 1000 and 30000.',
  minimum: 1000,
  maximum: 30000
}), __metadata("design:type", Number)], AdminRegistrationReminderRequestDto.prototype, "batchIntervalMs", void 0);
//# sourceMappingURL=AdminRegistrationReminderRequest.dto.js.map